import api from './api';

export interface CallOrder {
  id: number;
  order_number: string;
  stage: string;
  ship_by_date: string | null;
}

export interface CallBridgeClub {
  progress: number;
  until_reward: number;
}

export interface CallContext {
  known: boolean;
  from_number: string;
  name?: string;
  type_badge?: string;
  open_orders?: CallOrder[];
  open_order_count?: number;
  balance?: string | null;
  open_invoice_count?: number;
  open_invoice_total?: string | null;
  last_completed_order?: CallOrder | null;
  bridge_club?: CallBridgeClub | null;
}

export interface ActiveCall {
  call_key: string;
  from_number: string;
  session_id: string;
  received_at: string;
  context: CallContext;
}

/** Latest inbound call for the requesting seat, or null. Rides the polling endpoint. */
export const getActiveCall = async (): Promise<ActiveCall | null> => {
  const res = await api.get('/ringcentral/active-call/');
  return res.data?.call ?? null;
};

/** Persist the panel position per-user (called on drag END only). */
export const saveCallPanelPosition = async (x: number, y: number): Promise<void> => {
  await api.patch('/users/me/call-panel-position/', { x, y });
};
